import axios from 'axios';

axios.defaults.withCredentials = true;
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
// 创建axios实例
const service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://php.lxxmedia.com/task' : '/api',
  // baseURL: '/api',
  // 超时
  timeout: 10000
});

// 请求拦截
service.interceptors.request.use((config) => {
  const needToken = (config.headers || {}).needToken === true;
  if (localStorage.getItem('isShop') == 'true') {
    if (localStorage.getItem('jryjShop_token') && needToken) {
      config.headers['Authorization'] = localStorage.getItem('jryjShop_token'); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
  } else {
    if (localStorage.getItem('jryj_token') && needToken) {
      config.headers['Authorization'] = localStorage.getItem('jryj_token'); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
  }
  return config;
});

// 响应拦截器
service.interceptors.response.use((res) => {
  return res.data;
});
export default service;
